import React, { useState } from 'react';
import { Search, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Select } from './Select';
import { getFormattedLocations } from '../utils';

export function SearchBar() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const searchParams = new URLSearchParams();

    if (searchQuery) {
      searchParams.set('query', searchQuery);
    }
    if (selectedLocation) {
      searchParams.set('location', selectedLocation);
    }

    navigate(`/services?${searchParams.toString()}`);
  };

  const locations = getFormattedLocations(formatMessage);

  return (
    <form
      onSubmit={handleSubmit}
      className='bg-white rounded-lg p-2 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-0 sm:p-2 shadow-lg'
    >
      <div className='flex-1 flex items-center px-4 sm:border-r sm:border-gray-300'>
        <Search className='text-gray-400 mr-2' />
        <input
          type='text'
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder={formatMessage({
            id: 'search.placeholder.service',
            defaultMessage: 'Какую услугу ищете?',
          })}
          className='w-full py-2 focus:outline-none text-gray-700'
        />
      </div>

      <div className='relative w-full flex-1 flex items-center px-4 sm:border-l sm:border-gray-300'>
        <MapPin className='text-gray-400 mr-2' />
        <Select
          options={locations}
          placeholder={formatMessage({
            id: 'search.placeholder.city',
            defaultMessage: 'Выберите город',
          })}
          onChange={setSelectedLocation}
          value={selectedLocation}
          className='w-full focus:outline-none text-gray-700 bg-transparent no-borders no-padding no-divider'
        />
      </div>
      <button
        type='submit'
        className='bg-blue-600 text-white px-8 py-3 rounded-md hover:bg-blue-700 w-full sm:w-auto'
      >
        {formatMessage({
          id: 'search.button',
          defaultMessage: 'Найти',
        })}
      </button>
    </form>
  );
}
